import React from "react";
import Spacing from "../Spacing";
import { X } from "lucide-react";

export default function ServerHealth({
  checkServerHealth = false,
  setCheckServerHealth = () => {},
  checkServerHealthLoader = false,
  setCheckServerHealthLoader = () => {},
  serverHealthData = {}
}) {

  return (
    <>
      <Spacing lg="10" sm="10" />
      <div className="docpro_server_check relative">
        {!checkServerHealthLoader ? (
          <>
            <table className="docpro_referral_table">
              <tbody>
                <tr>
                  <td style={{ width: '95px' }}><strong>Patient</strong></td>
                  <td style={{ width: '15px' }}>:</td>
                  <td className={`${serverHealthData?.patient ? 'docpro_green_color' : 'docpro_red_color'}`}>v{serverHealthData?.patient || '0.0.0'}</td>
                </tr>
                <tr>
                  <td><strong>API</strong></td>
                  <td>:</td>
                  <td className={`${serverHealthData?.api ? 'docpro_green_color' : 'docpro_red_color'}`}>v{serverHealthData?.api || '0.0.0'}</td>
                </tr>
                <tr>
                  <td><strong>Notification</strong></td>
                  <td>:</td>
                  <td className={`${serverHealthData?.notification ? 'docpro_green_color' : 'docpro_red_color'}`}>v{serverHealthData?.notification || '0.0.0'}</td>
                </tr>
                <tr>
                  <td><strong>Payment</strong></td>
                  <td>:</td>
                  <td className={`${serverHealthData?.payment ? 'docpro_green_color' : 'docpro_red_color'}`}>v{serverHealthData?.payment || '0.0.0'}</td>
                </tr>
                <tr>
                  <td><strong>Worker</strong></td>
                  <td>:</td>
                  <td className={`${serverHealthData?.worker ? 'docpro_green_color' : 'docpro_red_color'}`}>v{serverHealthData?.worker || '0.0.0'}</td>
                </tr>
              </tbody>
            </table>
            <div className="absolute top-0 right-0 px-1 pointer"
              onClick={() => {
                setCheckServerHealth(false);
              }}
            >
              <X width={15} height={15} />
            </div>
          </>
        ) : (
          <div
            className="loading"
            style={{
              width: "100%",
              height: "100px",
              justifyContent: "center",
              display: "grid",
              alignContent: "center",
            }}
          >
            <p style={{ margin: "10px" }}>Loading...</p>
          </div>
        )}
      </div>
    </>
  );
}
